import {css} from "styled-components";
import currentTheme from "../../../react-themes/theme";

const theme = currentTheme();

const TextCss = css`
  .link-style {
    color: ${theme.colors.farmy.green};
    text-decoration: underline;
  }
  
  .font-size-body {
    font-size: ${theme.fonts.fontSizes.body}px;
  }

  .font-size-body-bigger {
    font-size: ${theme.fonts.fontSizes.bodyBigger}px;
  }
  
  .font-size-body-small {
    font-size: ${theme.fonts.fontSizes.bodySmall}px;
  }
  
  .font-size-body-smaller {
    font-size: ${theme.fonts.fontSizes.bodySmaller}px;
  }

  .font-size-body-tiny {
    font-size: ${theme.fonts.fontSizes.bodyTiny}px;
  }
  
  .font-size-h1 {
    font-size: ${theme.fonts.fontSizes.h1}px;
  }
  
  .font-size-h1-mobile {
      font-size: ${theme.fonts.fontSizes.h1Mobile}px;
  }

  .font-size-h2 {
    font-size: ${theme.fonts.fontSizes.h2}px;
  }

  .font-size-h2-mobile {
    font-size: ${theme.fonts.fontSizes.h2Mobile}px;
  }
  
  .font-size-h3 {
    font-size: ${theme.fonts.fontSizes.h3}px;
  }

  .font-size-h3-mobile {
    font-size: ${theme.fonts.fontSizes.h3Mobile}px;
  }
  
  .font-size-big {
    font-size: 110%;
  }
    
  .font-size-bigger {
    font-size: 120%;
  }
  
  .font-family-signika {
    font-family: 'Signika', 'PT Serif', Georgia, "Times New Roman", Times, serif;
  }
  
  .font-family-alata {
    font-family: 'Alata', 'Arial', sans-serif;
  }
  
  .font-size-big {
    font-size: 110%;
  }
    
  .font-size-bigger {
    font-size: 120%;
  }

  .text-small {
    font-size: 88%;
  }
  
  .text-smaller {
    font-size: 80%;
  }
  
  .text-smallest {
    font-size: 75%;
  };
  
  .text-strong {
    font-weight: 900;
  }
  
  .text-thin {
    font-weight: 100;
  }
  
  .line-height-1em {
    line-height: 1em;
  }
  
  .line-height-short {
    line-height: 1.3em;
  }
  
  .text-color-white {
    color: ${theme.colors.farmy.white};
  }
  
  .text-color-green {
    color: ${theme.colors.farmy.green};
  }
  
  .text-color-orange {
    color: ${theme.colors.farmy.orange};
  }
  
  .text-color-blue {
    color: ${theme.colors.farmy.blue};
  }
  
  .text-color-body {
    color: ${theme.colors.textColor};
  }

  .text-color-body-light {
    color: ${theme.colors.textLightColor}
  }

  .text-color-very-light-grey {
    color: ${theme.colors.farmy.veryLightGrey}
  }
  
  .text-color-info {
    color: ${theme.colors.info};
  }
  
  .text-color-danger {
    color: ${theme.colors.danger};
  }
  
  .text-color-dimmed {
    color: ${theme.colors.farmy.lightgrey}
  }
  
  .text-color-transparent {
    color: transparent;
  }
  
  .text-color-blue {
    color: ${theme.colors.farmy.blue}
  }

  .text-color-light-blue {
    color: ${theme.colors.farmy.lightBlue}
  }

  .word-break {
    word-break: break-all;
  }

  .hyphens-auto {
    hyphens: auto;
  }

  .overflow-wrap-break-word {
    overflow-wrap: break-word;
  }
  
  .capitalize {
    text-transform: capitalize;
  }
  
  .text-decoration-thin {
    text-decoration-thickness: 1px;
  }
  
  .text-decoration-none {
    text-decoration: none;
  }
`;

export default TextCss;
